import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestGetResellersFilterLimits } from "./getResellersFilterLimits.request";
import { GetResellersFilterLimitsResponse } from "./getResellersFilterLimits.types";

const useGetResellersFilterLimits = (
  options?: QueryOptions<
    GetResellersFilterLimitsResponse,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["reseller", "admin", "calculate-with-order-statistics"],
    queryFn: requestGetResellersFilterLimits,
    onError: toastServerError,
    ...options
  });

  return { filterLimits: data, ...rest };
};

export default useGetResellersFilterLimits;
